import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';

/**
 * Generated class for the AddholidayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-addholiday',
  templateUrl: 'addholiday.html',
})
export class AddholidayPage {
  gr: any;
  Title = ''
  dat: any;
  nameHoliday = ''
  _dt
  ka = new Date()
  am: any


  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController) {
    this.gr = navParams.get('gr')
    console.log(this.gr, 'daj tuka gr da vidam')
    this.dat = navParams.get('dat')
    // this.am = navParams.get('am')


    // console.log(this.dat,'daj mi datum')
    // this.dat.split(' ')

    // this.ka = this.dat
    // var n = this.ka.getDay()
    // console.log(n,'daj mi den od ned')


    // console.log(this.dat.getDay(),'cisto informativno sto ke mi dade')


    // console.log(this._dt,'daj mi datum da vidam')


    if (this.gr.id == -1) {
      this.ka = new Date(this.dat)
      // console.log(this.ka,'ajde daj mi ka')
      // console.log(this.ka,'daj da vzirnam')
      // this.ka.getDay()
      console.log(this.ka.getDay(), 'daj mi broj')

      // console.log(this.dat.getDay(),'daj da vidam sto ke pec')

      this._dt = this.dat.split(' ')[0].split('-')[2] + '-' + this.dat.split(' ')[0].split('-')[1] + '-' + this.dat.split(' ')[0].split('-')[0]
      this.Title = this.dic.l["addHoliday"] + ' : ' + this._dt
    } else {
      this.Title = this.dic.l["editHoliday"]
      this.nameHoliday = this.gr.dayname
      // this.obj = navParams.get('obj')
      //   console.log(this.obj,'daj da vidam od g')

    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddholidayPage');
  }

  // save(){
  //   this.gr.id
  //   this.nameHoliday
  //   console.log(this.gr.id)
  //   console.log(this.nameHoliday)
  // }

  Save() {

    var typeday = this.ka.getDay()
    if (typeday == 0) {
      typeday = 7
    }

    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      dayname: this.gn.crypt(this.nameHoliday),
      typeofday: this.gn.crypt(typeday),
      datum: this.gn.crypt(this.dat),
      id: this.gn.crypt(this.gr.id)
    }

    var _datOrg = {
      cid: this.gn.user.ClientId,
      dayname: this.nameHoliday,
      typeofday: typeday,
      datum: this.dat,
      datum1: this.dat,
      id: this.gr.id
    }

    var _that = this
    this.gn._Post('/api/gn/insertdate', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      if (_cb != null) {
        _datOrg.id = _data.dat[0].id
        _datOrg.datum1 = _data.dat[0].datum
        _cb(_datOrg, _that.gr.id)
      }
      var _cb1 = _that.navParams.get('cb1')
      if (_cb1 != null) {
        _cb1(_that.nameHoliday)
      }
      var _msg = _that.dic.l["succaddholiday"]
      if (_that.gr.id + '' != '-1') {
        _msg = _that.dic.l["succedditholiday"]
      }
      let toast = _that.toastCtrl.create({
        message: _msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
      _that.navCtrl.pop()
    })
  }



}



// WEBPACK FOOTER //
// ./src/pages/settings/holiday/addholiday.ts